// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import GameConfig from '../config/GameConfig';
import STORAGE_KEYS from './system/STORAGE_KEYS';

/**
 * Get current difficulty multipliers from localStorage setting.
 * Falls back to 'normal' if unset.
 */
export const getDifficultyMultipliers = () => {
  const setting = localStorage.getItem(STORAGE_KEYS.DIFFICULTY) || 'normal';
  return GameConfig.difficulty[setting] || GameConfig.difficulty.normal;
};
